// Models
import { createContactUsStoreDefaultModel } from './contact-us/contact-us.store'

const contactUsModels = {
  contactUs: createContactUsStoreDefaultModel(),
}

export { contactUsModels }
